import Vivus from 'vivus'

$('.js-indexHover').on('mouseenter', (e) => {
  const id = $(e.currentTarget).data('id')

  $('.index-hero-book-preview').addClass('is_hide')
  $(`[data-hover-preview="${id}"]`).addClass('is_active')
})

$('.js-indexHover').on('mouseleave', () => {
  $('.index-hero-book-preview').removeClass('is_hide')
  $('[data-hover-preview]').removeClass('is_active')
})

setTimeout(() => {
  $('.index-hero-video').addClass('is_show')
}, 500)

setTimeout(() => {
  $('.index-hero-svg').addClass('is_show')
  $('.index-hero-svg svg').each((index, el) => {
    vivusSvgAnimation($(el))
  })
}, 1000)

setTimeout(() => {
  $('.index-hero-play').addClass('is_show')
  $('.index-hero-book-preview').addClass('is_show')
}, 2000)

function vivusSvgAnimation(svgEl) {
  const svg = svgEl.attr('id')
  const timing = 70

  new Vivus(svg, {
    duration: timing,
    type: 'delayed',
    start: 'autostart',
    selfDestroy: true,
  }, (() => {

  }))
}

const promoPanel = $('.promo-panel')

$(window).on('scroll load resize', () => {
  if ($('.budget-banner').length > 0) {
    const scrolled = $(window).scrollTop()
    const bannerOffsert = $('.budget-banner').offset().top
    const feedback = $('.section-feedback').offset().top - ($(window).height() / 2)

    if (scrolled > bannerOffsert && scrolled < feedback) {
      promoPanel.addClass('is_show')
    } else {
      promoPanel.removeClass('is_show')
    }
  }
})
